import React from 'react'
import './Portfolio.css'
import {Swiper, SwiperSlide} from 'swiper/react'
// import Sidebar from '../../img/sidebar.png'; 
// import Ecommerce from '../../img/ecommerce.png'; 
// import HOC from '../../img/hoc.png'; 
// import MusicApp from '../../img/musicapp.png'; 
import TwitterSentiment from '../../img/MyStuff/twittersentiments.png'; 
import CustomerChurn from '../../img/MyStuff/customerchurn.png'; 
import CabPooling from '../../img/MyStuff/cabpooling.png'; 
import OnlineVoting from '../../img/MyStuff/onlinevoting.png'; 
import FaceRecognition from '../../img/MyStuff/facerecognition.png'; 
import 'swiper/css'
import { themeContext } from '../../Context';
import { useContext } from 'react';
import { Autoplay } from 'swiper';
const Portfolio = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="Portfolio">
        {/* heading */}
        <span style={{color: darkMode? 'white' : ''}}>Recent Projects</span>
        <span>Portfolio</span>
        <span>Click on Projects to get more details</span>
        { /* Swiper */}
        <Swiper  slidesPerView={1.8} grabCursor={true}  className="portfolio-slider" > 
            <SwiperSlide>
                <a href="https://akash701752-twitter-sentiment-streamlit-home-4mx2e6.streamlit.app/" target={"_blank"}><img src={TwitterSentiment} alt="" /> </a>
            </SwiperSlide>
            <SwiperSlide>
                <a href="https://github.com/akash701752/Customer_Churn_Analysis.git" target={"_blank"}><img src={CustomerChurn} alt="" /> </a>
            </SwiperSlide>
            <SwiperSlide>
                <a href="https://github.com/akash701752/Cab-Pooling-Project.git" target={"_blank"}><img src={CabPooling} alt="" /> </a>
            </SwiperSlide>
            <SwiperSlide>
                <a href="https://github.com/akash701752/Online-Voting-System.git" target={"_blank"}><img src={OnlineVoting} alt="" /> </a>
            </SwiperSlide>
            <SwiperSlide>
                <a href="https://github.com/akash701752/Face_Recognition_System.git" target={"_blank"}><img src={FaceRecognition} alt="" /> </a>
            </SwiperSlide>
        </Swiper>
    </div>
  )
}

export default Portfolio